import React, {Component} from 'react';
import './styles.css';
import CardHelper from "../../helpers";
import { Dates } from '../../../../packages/dates';
import Assets from '../../../../requests/apa/Asset';
import Utils from '../../../../utils/Utils';
import Metadata from "../../../../requests/apa/Metadata";
import DeviceStorage from '../../../../components/DeviceStorage/DeviceStorage';
import EventTagCarrusel from '../../../../components/PersistentMiniEpg/EventTagCarrusel';
import { getCoverStyle, isPS4Platform, clearCoverRef } from '../ps4ImageUtils';

const _isPS4 = isPS4Platform();

class CardLiveEventsChannels extends Component{
  constructor(props) {
    super(props);
    this.state = {
      showActions: props.showActions,
      imageReady: !_isPS4,
    };
    this.channelNumber = props.channelNumber;
    this.title = props.title;
    this.channelBlocked = props.channelBlocked;
    this.data = props.data;
    this.subtitle = props.subtitle;
    this.startTime = props.startTime;
    this.endTime = props.endTime;
    this.bookmark = props.bookmark;
    this.showActions = props.showActions;
    this.id = props.id;
    this.temporality = 0;
    this.dayTemporality = '';
    this.group_id = props.group_id;
    this.imageChannel = props.imageChannel;
    this.imageEvent = props.imageEvent;

    this.BlockedIcon = Assets.get('Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_IconoBloqueado');
    this.FavoriteIcon = Assets.get('Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_IconoFavorito');
    this.Tag_TextoTitulo_Ahora = Metadata.get('Tag_TextoTitulo_Ahora', 'Tag_TextoTitulo_Ahora');
    this.Tag_TextoTitulo_YaEmitido = Metadata.get('Tag_TextoTitulo_YaEmitido', 'Tag_TextoTitulo_YaEmitido');
    this.Tag_TextoTitulo_MasTarde = Metadata.get('Tag_TextoTitulo_MasTarde', 'Tag_TextoTitulo_MasTarde');
    this.Tag_Hoy = Metadata.get('Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_TextoHoy', 'Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_TextoHoy');
    this.Tag_Ayer = Metadata.get('Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_TextoAyer', 'Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_TextoAyer');
    this.Tag_Manana = Metadata.get('Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_TextoManana', 'Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_TextoManana');
    this.Color_ColorAhora = Metadata.get('Color_ColorAhora ', 'Color_ColorAhora');
    this.Color_ColorMasTarde = Metadata.get('Color_ColorMasTarde ', 'Color_ColorMasTarde');
    this.Color_ColorYaEmitido = Metadata.get('Color_ColorYaEmitido ', 'Color_ColorYaEmitido');
    this.Color_ColorTemporality = this.Color_ColorAhora;
    this.BarraDeProgreso_V2_ColorFondo = Metadata.get('BarraDeProgreso_V2_ColorFondo ', 'BarraDeProgreso_V2_ColorFondo');
    this.BarraDeProgreso_V2_ColorProgreso = Metadata.get('BarraDeProgreso_V2_ColorProgreso ', 'BarraDeProgreso_V2_ColorProgreso');
    this.Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_ColorFondo = Metadata.get('Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_ColorFondo', 'Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_ColorFondo');
    this.isBlockedChannel = Utils.isLiveEventPinBlocked(this.group_id);
    this.isfavoriredChannel = Utils.isFavoritedLiveEventPinBlocked(this.group_id);
    this.isOnlyOld = this._checkIsOnlyOld();

    this._coverRef = null;
    this._loadTimer = null;
    this._setCoverRef = this._setCoverRef.bind(this);

    // Cache
    this._cachedCoverStyle = null;
    this._prevCoverUrl = undefined;
    this._prevImageReady = undefined;
  }

  _checkIsOnlyOld() {
    const objectMeta = Metadata.get('adult_channel_rating','{"adult_channel_rating": {"default": {"rating_code": "NC-17","parental_rating": "+18"},"mexico": {"rating_code": "NC-17","parental_rating": "+18"}}}');
    let channelRatingMetadata = JSON.parse(objectMeta);
    const region = DeviceStorage.getItem('region');
    channelRatingMetadata = channelRatingMetadata.adult_channel_rating[region] || channelRatingMetadata.adult_channel_rating['default'];

    const ratingData = this.props.data && this.props.data.data;
    const channelRatingEvent = ratingData && ratingData.rating && ratingData.rating[0] && ratingData.rating[0].code;
    return channelRatingMetadata.parental_rating === channelRatingEvent && channelRatingMetadata.parental_rating === '+18';
  }

  componentDidMount() {
    if (!this.state.imageReady) {
      this._loadTimer = setTimeout(this._onImageReady, _isPS4 ? 200 : 150);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.showActions !== this.state.showActions){
      this.setState({showActions: nextProps.showActions});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.showActions !== nextState.showActions ||
      this.state.imageReady !== nextState.imageReady
    );
  }

  componentWillUnmount() {
    if (this._loadTimer) {
      clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
    clearCoverRef(this._coverRef);
    this._coverRef = null;
    this._cachedCoverStyle = null;
  }

  _onImageReady = function() {
    this.setState({ imageReady: true });
  }.bind(this);

  _setCoverRef(el) {
    this._coverRef = el;
  }

  getStartEndTimeMovie(dateStr){
    return new Dates().unix(dateStr).format('HH:mm');
  }

  getDayAndMonth(dateStr){
    const date = new Date(dateStr * 1000);
    const formato = date.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'short'
    });
    return formato;
  }

  obtenerEtiqueta(unix_begin, unix_end) {
    const ahora = Utils.now();
    const fechaHoy = ahora;
    const fechaInicio = new Date(unix_begin * 1000);
    const esMismoDia = fechaInicio.toDateString() === fechaHoy.toDateString();

    if (ahora >= unix_begin && ahora <= unix_end) {
      this.temporality = 1;
      return this.Tag_TextoTitulo_Ahora;
    }

    if (ahora < unix_begin && esMismoDia) {
      this.temporality = 2;
      this.dayTemporality = this.Tag_Hoy;
      this.Color_ColorTemporality = this.Color_ColorMasTarde;
      return this.Tag_TextoTitulo_MasTarde;
    }

    if (ahora > unix_end && esMismoDia) {
      this.temporality = 3;
      this.dayTemporality = this.Tag_Hoy;
      this.Color_ColorTemporality = this.Color_ColorYaEmitido;
      return this.Tag_TextoTitulo_YaEmitido;
    }

    const inicioSinHora = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate());
    const hoySinHora = new Date(fechaHoy.getFullYear(), fechaHoy.getMonth(), fechaHoy.getDate());

    const diferenciaDias = Math.round((hoySinHora - inicioSinHora) / (1000 * 60 * 60 * 24));
    const diferenciaDiasMayor = Math.round((inicioSinHora - hoySinHora) / (1000 * 60 * 60 * 24));

    if (diferenciaDias === 1) {
      this.temporality = 4;
      this.dayTemporality = this.Tag_Ayer;
      this.Color_ColorTemporality = this.Color_ColorYaEmitido;
      return this.Tag_TextoTitulo_YaEmitido;
    }

    if (diferenciaDias > 1) {
      this.temporality = 5;
      this.Color_ColorTemporality = this.Color_ColorYaEmitido;
      return this.Tag_TextoTitulo_YaEmitido;
    }

    if (diferenciaDiasMayor === 1) {
      this.temporality = 6;
      this.dayTemporality = this.Tag_Manana;
      this.Color_ColorTemporality = this.Color_ColorMasTarde;
      return this.Tag_TextoTitulo_MasTarde;
    }

    if (diferenciaDiasMayor > 1) {
      this.temporality = 7;
      this.Color_ColorTemporality = this.Color_ColorMasTarde;
      return this.Tag_TextoTitulo_MasTarde;
    }

    return 'Etiqueta no definida';
  }

  convertUnixDate(dateFull){
    const date = new Date(dateFull);
    return Math.floor(date.getTime() / 1000);
  }

  render() {
    const startUnix = this.convertUnixDate(this.props.startTime);
    const endUnix = this.convertUnixDate(this.props.endTime);
    const hStart = this.getStartEndTimeMovie(startUnix);
    const hEnd = this.getStartEndTimeMovie(endUnix);
    const pgress = CardHelper.getTimeProgress(startUnix, endUnix);
    const Tag_TextoTitulo_Tempo = this.obtenerEtiqueta(startUnix, endUnix);

    // Actualizar cover style solo si cambió
    const coverUrl = this.isOnlyOld ? this.imageChannel : this.imageEvent;
    const imageReady = this.state.imageReady;
    if (coverUrl !== this._prevCoverUrl || imageReady !== this._prevImageReady) {
      this._prevCoverUrl = coverUrl;
      this._prevImageReady = imageReady;
      this._cachedCoverStyle = getCoverStyle(coverUrl, imageReady);
    }

    return (
      <div className='card card-last-viewed-livechannel'>
        <div className="card-header">
          <span className="channel-number">{this.channelNumber}</span>
          <span className="channel-name">{this.title}</span>

            {this.isfavoriredChannel && <span className="favorite-icon">
              {this.FavoriteIcon}
            </span>
            }
        </div>
        <div className={'card-container-events-channels'}>
          <div
            ref={this._setCoverRef}
            className='card-cover-events-channels'
            style={this._cachedCoverStyle}
          />
          {CardHelper.createProgressBarLastChannelViewed(pgress, this.BarraDeProgreso_V2_ColorFondo, this.BarraDeProgreso_V2_ColorProgreso)}
        </div>
        <div className="card-subtitle">{this.subtitle}</div>
          <div className="card-footer">
           <EventTagCarrusel
              wrapperId={'modal_1_events'}
              spanId={'modal_span_id_events'}
              style={{backgroundColor: this.Color_ColorTemporality, width:'auto' }}
              text = {Tag_TextoTitulo_Tempo}
            />
            <span className="date"> {this.dayTemporality} </span>
            {(this.temporality === 7 || this.temporality === 5) && <span className="date"> {this.getDayAndMonth(startUnix)}. </span>}
            {this.temporality > 1 && <span className="pipe">|</span>}
            <span className="time"> {hStart} - {hEnd}</span>
          </div>
      </div>
    );
  }
}

export default CardLiveEventsChannels;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardLiveEventsChannels/index.js